import { render, staticRenderFns } from "./round-edit.vue?vue&type=template&id=86d8a7fe&scoped=true&"
import script from "./round-edit.vue?vue&type=script&lang=js&"
export * from "./round-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86d8a7fe",
  null
  
)

export default component.exports